import React from 'react';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import assets from 'marketing-website/configs/pages/pricing/assets';
import Image from '../../components/modules/Image';

export default function CtaFooter() {
  return (
    <div className="bg-marvel c-white">
      <Spacing size="l" position="topBottom" type="padding">
        <PageWrap>
          <Spacing size="xl" position="topBottom" type="padding">
            <Grid columns={2} size="xl" alignItems="center">
              <GridItem columnSpan={2} columnSpanM={1}>
                <Align type="center" typeM="left">
                  <MaxWidth value={400}>
                    <Heading color="white" size="xxxl" weight="semibold">
                      Thousands of teams use Marvel to make design their
                      competitive edge.
                    </Heading>
                  </MaxWidth>
                </Align>
              </GridItem>
              <GridItem columnSpan={2} columnSpanM={1}>
                <Image
                  {...assets.customerLogos}
                  hasShadow={false}
                  useImageTag={false}
                />
              </GridItem>
            </Grid>
          </Spacing>
        </PageWrap>
      </Spacing>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pricing/CtaFooter.js